import styled, { css } from 'styled-components';

import Image from '@components/Image';

const ImageContainer = styled.div`
  height: ${({ theme }) => theme.commons.productItem.imageContainer.height};
  max-height: ${({ theme }) => theme.commons.productItem.imageContainer.height};
  overflow: hidden;
  ${Image} {
    display: block;
    width: 100%;
  }
  border-radius: ${({ theme }) => theme.spacing(3, 3, 0, 0)};
  ${({ isDesktopLayout }) =>
    isDesktopLayout &&
    css`
      display: flex;
      align-items: center;
      justify-content: center;
    `}
`;

export default ImageContainer;
